import { useTheme } from '@mui/material'
import { FC } from 'react'

import { useTranslation } from 'react-i18next'
import { XboxSVG } from '../../components/icons/XboxIcon'
import { PlatformSelectBox } from '../../components/PlatformSelectBox/PlatformSelectBox'
import { useConfig } from '../../providers/envConfig'
import { colors } from '../../theme/options'
import { FirstPartyPlatformType } from '../../types/Account'
import { getCurrentLanguageFromUrl } from '../../utils/language.ts'

const XboxPlatformSelectBox: FC = () => {
  const envConfig = useConfig()
  const theme = useTheme()
  const { t } = useTranslation('vpc', { keyPrefix: 'login' })

  const handleXboxLogin = () => {
    window.location.href = `https://login.live.com/oauth20_authorize.srf?client_id=${envConfig.xbox.clientId}&response_type=code&redirect_uri=${encodeURIComponent(envConfig.xbox.callbackUri)}&scope=${encodeURIComponent(envConfig.xbox.scope)}&ui_locales=${getCurrentLanguageFromUrl()}`
  }

  return (
    <PlatformSelectBox
      data-testid="platform-select-box-xbox"
      color={colors.xbox}
      title={t(`${FirstPartyPlatformType.XBOXLIVE.toLowerCase()}.name`)}
      icon={<XboxSVG sx={{ color: theme.palette.common.white, fontSize: '2.5rem' }} />}
      onClick={() => handleXboxLogin()}
    />
  )
}

export default XboxPlatformSelectBox
